import React from 'react';
import { useStyles } from '../style';

export const ID_RESULTS_FOUND = 'vehicle-autocomplete-results-found';
export const ID_LOADING = 'vehicle-autocomplete-loading';

export const ListBoxVehicleComponent = React.forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>((params, ref) => {
  const classes = useStyles();

  return (
    <>
      <div id={ID_RESULTS_FOUND} className={classes.containerResultsFound} />
      <ul ref={ref} {...params} style={{ padding: 0, maxHeight: 300 }} />
      <div id={ID_LOADING} className={classes.containerLoading} />
    </>
  );
});

ListBoxVehicleComponent.displayName = 'ListBoxVehicleComponent';
